import React, { FC, ChangeEvent } from 'react';
import { validateFullName } from 'utils';
import Input, { TextProps } from '../Input';

const FullName: FC<TextProps> = ({ value, onChange, className, rules, ...props }) => {
  const isFullNameInvalid = !!validateFullName(value as string);
  return (
    <Input
      value={value}
      label="Full name"
      placeholder="Full name"
      maxLength={100}
      {...props}
      type="text"
      className={className}
      onChange={(event: ChangeEvent<HTMLInputElement>) => onChange && onChange(event)}
      rules={{
        ...rules,
        errorMessage: validateFullName(value as string) || rules?.errorMessage,
        hasError: isFullNameInvalid || rules?.hasError,
      }}
    />
  );
};

export default FullName;
